import React, {useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {useSelector, useDispatch} from 'react-redux';

import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import {Link} from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';

import {fetchAuthToken, selectAuth} from '../features/users/auth.js';

const ColorButton = withStyles((theme) => ({
  root: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: '#D86D7E',
    color: '#FFF',
    '&:hover': {
      opacity: 0.9,
      backgroundColor: '#D86D7E',
    },
    // fontWeight: 'bold',
  },
}))(Button);

const BlueCheckbox = withStyles({
  root: {
    '&$checked': {
      color: '#42494E',
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

const useStyles = makeStyles((theme) => ({
  // #42494E; light blue
  // #131f47; dark blue
  // #ed5e9d; pink
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderRadius: '10px',
    backgroundColor: '#FFF',
    padding: '45px',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  linkText: {
    fontSize: 16,
    display: 'flex',
    alignItems: 'center',
  },
  remember: {
    display: 'block',
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: '#42494E',
    color: '#FFF',
  },
}));

export default function SignIn() {
  const history = useHistory();
  const dispatch = useDispatch();
  const classes = useStyles();

  const {auth, error, loading, signedIn} = useSelector(selectAuth);
  let jwtToken = localStorage.getItem('coreToken');

  if (jwtToken) {
    history.push('/products');
  }

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const submitSignIn = (event) => {
    event.preventDefault();

    const credentials = {
      grant_type: 'password',
      username: username,
      password: password,
    };

    dispatch(fetchAuthToken(credentials));
  };

  return (
    <Card
      elevation={4}
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
      }}
    >
      <Container className={classes.paper} component="main" maxWidth="xs">
        <CssBaseline />
        <div>
          <img src="/ps-logo-new.png" style={{width: "20rem"}} alt="logo" />{' '}

        </div>
        <form className={classes.form} onSubmit={submitSignIn}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="username"
            label="Username"
            name="username"
            autoComplete="username"
            autoFocus
            onChange={(e) => setUsername(e.target.value)}
            error={error}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            onChange={(e) => setPassword(e.target.value)}
            error={error}
            helperText={error ? error.message : ''}
          />

          <ColorButton type="submit" fullWidth variant="contained">
            Sign In
          </ColorButton>
          <Grid container>
            <Grid item xs>
              <FormControlLabel
                control={<BlueCheckbox value="remember" />}
                label="Remember me"
                className={classes.remember}
              />
            </Grid>
            <Grid className={classes.linkText} item xs>
              <Link to="/forgotpassword">Forgot password?</Link>
            </Grid>
          </Grid>
        </form>
      </Container>
    </Card>
  );
}
